<template>
  <v-container fluid class="text-center">
    <v-row justify="center">
      <v-btn v-if="!inProgress" x-large color="secondary" @click="goToAuthPage">
        <span class="color-white">{{ $t('auth.login') }}</span>
      </v-btn>
    </v-row>
    <v-alert v-if="inProgress" border="left" color="secondary" dark class="mt-4">
      {{ $t('auth.login_processing') }}
    </v-alert>
    <v-alert v-if="error" border="left" color="red lighten-2" dark class="mt-4">
      {{ errorMessage }}
    </v-alert>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import config from '../../config/ConfigProvider';

export default {
  name: 'LandingPageInfo',

  components: {},

  data: () => ({
    error: false,
    errorMessage: '',
    serviceName: config.value('serviceName'),
  }),

  computed: {
    ...mapState('authentication', ['inProgress', 'reauthenticate']),
    ...mapGetters('profile', ['hasCurrentProfile']),
  },
  mounted() {
    this.checkAuthentication();
    document.body.classList.add('login', 'login');
  },
  destroyed() {
    document.body.classList.remove('login', 'login');
  },

  methods: {
    ...mapActions('authentication', [
      'changeCodeVerifier',
      'setInProgress',
      'authenticateWithCode',
      'setReauthenticate',
      'clearTokens',
    ]),
    ...mapActions({ login: 'auth/login' }),
    ...mapGetters('authentication', ['getCodeVerifier', 'getAccessToken', 'getLoginParams', 'loggedIn']),
    checkAuthentication() {
      if (typeof this.$route.query.reauthenticate !== 'undefined') {
        this.loginWithSSO();
      } else if (typeof this.$route.query.code !== 'undefined') {
        this.onAuthenticateWithCode();
      } else if (this.getCodeVerifier().length === 0 || this.getAccessToken() === '') {
        this.changeCodeVerifier();
      }
    },

    async loginWithSSO() {
      await this.clearTokens(false);

      this.setReauthenticate(this.$route.query.reauthenticate);
      this.changeCodeVerifier();

      const SSOLoginParams = this.getLoginParams();
      SSOLoginParams.append('reauthenticate', this.reauthenticate);
      window.location = `${config.value('authUrl')}v1/authorize?${SSOLoginParams.toString()}`;
    },

    async onAuthenticateWithCode() {
      try {
        await this.authenticateWithCode(this.$route.query.code);
        this.login();
      } catch (error) {
        await this.showErrorMessage(error);
      }
    },

    showErrorMessage(error) {
      this.setInProgress(false);
      this.error = true;
      this.errorMessage = error.message ?? this.$t('auth.login_error');
    },

    goToAuthPage() {
      this.changeCodeVerifier();
      window.location = `${config.value('authUrl')}v1/authorize?${this.getLoginParams().toString()}`;
    },
  },
};
</script>

<style scoped>
#main-content {
  text-align: center;
  max-width: 34em;
  margin: auto;
}

#welcome-message {
  margin-bottom: 1em;
}

.v-btn {
  border-radius: 25px;
}

.row {
  margin: auto;
}
</style>
